import { styled } from '@mui/material';

export const HeaderW = styled('div')`
  display: flex;
  position: relative;
  justify-content: space-between;
  align-items: center;
  color: ${({ theme }) => theme.palette.primary.p080};
  padding-bottom: 16px;
`;
